// extracted by mini-css-extract-plugin
export var link = "_re-0";